import { Balance } from "../domain/models/Balance";
import { BalanceRepository } from "../domain/repositories/BalanceRepository";
import { DepositAccount } from "../domain/models/DepositAccount";
import { Commission } from "../domain/models/Commission";
import { axiosApp } from './remote/AxiosFactory';
import { handleRemoteResponse } from './remote/hanldeRemoteResponse';
import { handleAxiosResult } from './remote/handleAxiosResult';

export class BalanceDataRepository implements BalanceRepository {
    async getCommissions(): Promise<Commission[]> {
        const result = await handleAxiosResult(axiosApp().get(`pos/comisiones?`));
        return handleRemoteResponse(result, (r: any) => {
            return r.map((e: any) => {
                return new Commission({
                    ...e,
                    comision: parseFloat(`${e.comision}`)
                });
            })
        })
    }

    async getDepositAccounts(): Promise<DepositAccount[]> {
        const result = await handleAxiosResult(axiosApp().get(`pos/deposit/accounts?`));
        return handleRemoteResponse(result, (r: any) => {
            return r.map((e: any) => {
                return new DepositAccount({
                    id: e.banco_id,
                    bank: e.banco,
                    clabe: e.cuenta_clabe,
                    name: e.destino_nombre,
                    accountNumber: e.cuenta_id,
                    store: e.cuenta_sucursal,
                    logo: e.banco_logo,
                    typeDeposit: e.tipo_pago,
                    accountCard: e.cuenta_tarjeta
                });
            })
        })
    }

    async getBalance(token: string): Promise<Balance> {
        const result = await handleAxiosResult(axiosApp().get(`pos/balance?token=${token}`))
        return handleRemoteResponse(result, (r: any) => {
            return new Balance({
                balance: r.balance,
                date_hour: r.date_hour,
                init_balance: r.init_balance,
                movs_balance: r.movs_balance,
                ops_balance: r.ops_balance,
                pos: r.pos,
                profits: r.profits,
                total: r.total,
                pendiente_2fa: r.pendiente_2fa,
                cobro_servicio: r.cobro_servicio,
                ajuste_comision_compra: r.ajuste_comision_compra
            });
        })
    }
}